export const HEADER_TYPES = {
    ALL: 'all',
    CLOSE_ONLY: 'closeOnly'
} as const;

export type HeaderType = typeof HEADER_TYPES[keyof typeof HEADER_TYPES];